import { Progress } from 'antd';
import PropTypes from 'prop-types';

const ProgressBar = ({
  title,
  subtitle = '',
  percent,
  color,
  showPercent = true,
  withLineBreak = false
}) => {
  const isLongSubtitle = subtitle.length > 80;
  const marginBottom = showPercent ? 'mb-3 mt-3' : 'mb-1';
  return (
    <div
      className={`${marginBottom} text-baxterGray cursor-pointer`}
      style={{ fontSize: '12px' }}>
      <div className="flex flex-wrap justify-between items-end">
        <span className="text-left w-4/5">
          <strong>{title} </strong>
          {withLineBreak && <br />}
          {isLongSubtitle ? (
            <div className="text-left">{subtitle}</div>
          ) : (
            subtitle
          )}
        </span>
        {showPercent && (
          <strong className="text-right w-1/5">{percent}%</strong>
        )}
      </div>
      <Progress
        strokeColor={color}
        strokeLinecap="square"
        showInfo={false}
        percent={percent}
      />
    </div>
  );
};

/**
 * Component definition of proptypes.
 */
ProgressBar.propTypes = {
  dataValues: PropTypes.array,
  title: PropTypes.any,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  percent: PropTypes.any,
  color: PropTypes.string,
  showPercent: PropTypes.bool,
  withLineBreak: PropTypes.bool
};

export default ProgressBar;
